import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../../services/FirebaseService'
import { liabilityLimitPretty, KPretty } from '../../../../services/utils'
import { isMobile } from 'react-device-detect'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { WorldWideOption } from '../../../../models/insurance-models/WorldWideOption'
import { PolicyRenewalContextStore } from '../../../../context/PolicyRenewalContext'
import { SUBSCRIPTION_STATE } from '../../../../models/insurance-models/PolicySubscriptionState'

var classNames = require('classnames')

interface PolicyAdditionalCoveragesSectionProps {
    insurance: ActiveInsuranceModel;
}

export const PolicyAdditionalCoveragesSection = ({
    insurance,
}: PolicyAdditionalCoveragesSectionProps) => {
    const policyRenewalContext = useContext(PolicyRenewalContextStore)

    var currentInsurance = insurance

    if (
        policyRenewalContext.insuranceSubscriptionState ==
        SUBSCRIPTION_STATE.RENEWAL
    ) {
        currentInsurance = policyRenewalContext.renewalOffers.find(
            (l) => l.liabilityLimit == insurance.subscription.liabilityLimit
        )

        if (!currentInsurance) currentInsurance = insurance
    }

    return (
        <>
            <FlexView className="space-between margin-bottom-basic">
                <div className="text-body bold black">Additional Coverages</div>
            </FlexView>
            {currentInsurance.indoorCoveragePremium > 0 && (
                <FlexView
                    column={isMobile}
                    className={classNames(
                        { 'space-between': !isMobile },
                        'margin-top-small'
                    )}
                >
                    <div className="black text-small">Indoor Coverage</div>
                    <div className="gray margin-top-small text-tiny">
                        Premium:{' '}
                        {FirebaseService.getValue(
                            FirebaseConfigKey.CURRENCY_SYMBOL
                        )}
                        {currentInsurance.indoorCoveragePremium.toLocaleStringToFixed()}
                    </div>
                </FlexView>
            )}
            {currentInsurance.personalInjuryLimitPremium > 0 && (
                <FlexView
                    column={isMobile}
                    className={classNames(
                        { 'space-between': !isMobile },
                        'margin-top-small'
                    )}
                >
                    <div className="black text-small">
                        {KPretty(currentInsurance.personalInjuryLimit)} Personal
                        Injury Coverage (Including Privacy)
                    </div>
                    <div className="gray margin-top-small text-tiny">
                        Premium:{' '}
                        {FirebaseService.getValue(
                            FirebaseConfigKey.CURRENCY_SYMBOL
                        )}
                        {currentInsurance.personalInjuryLimitPremium.toLocaleStringToFixed()}
                    </div>
                </FlexView>
            )}
            {currentInsurance.medicalExpenseLimitPremium > 0 && (
                <FlexView
                    column={isMobile}
                    className={classNames(
                        { 'space-between': !isMobile },
                        'margin-top-small'
                    )}
                >
                    <div className="black text-small">
                        {KPretty(currentInsurance.medicalExpenseLimit)} Medical
                        Expenses
                    </div>
                    <div className="gray margin-top-small text-tiny">
                        Premium:{' '}
                        {FirebaseService.getValue(
                            FirebaseConfigKey.CURRENCY_SYMBOL
                        )}
                        {currentInsurance.medicalExpenseLimitPremium.toLocaleStringToFixed()}
                    </div>
                </FlexView>
            )}
            {currentInsurance.territorialLimits ==
                WorldWideOption.Worldwide && (
                <FlexView
                    column={isMobile}
                    className={classNames(
                        { 'space-between': !isMobile },
                        'margin-top-small'
                    )}
                >
                    <div className="black text-small">Worldwide Coverage</div>
                    <div className="gray margin-top-small text-tiny">
                        Premium:{' '}
                        {FirebaseService.getValue(
                            FirebaseConfigKey.CURRENCY_SYMBOL
                        )}
                        {currentInsurance.territorialLimitsPremium.toLocaleStringToFixed()}
                    </div>
                </FlexView>
            )}
        </>
    )
}
